import {apiPost, apiPostWithRetry} from './client';
import {ACCOUNT_ID} from './account';

// Дев-режим против мока (VITE_ZVONKI_MOCK=true): текст приходит через ~1с,
// превью — короткий тихий MP3, «планирование» завершается статусом scheduled
// через ~2с. По умолчанию выключен — фронт ходит в реальный API звонков.
const MOCK = import.meta.env.VITE_ZVONKI_MOCK === 'true';

const MOCK_TEXTS = [
    'Привет! Это твоя любимая звезда. Поздравляю с днём рождения — обнимаю и желаю счастья!',
    'Здравствуй! Звоню лично поздравить: пусть сбудутся все мечты. Ты — супер!',
];

// ~0.15s of silence (valid LAME mp3), enough for the <audio> element to actually play.
const MOCK_AUDIO_BASE64 = '//NAxAAAAANIAAAAAExBTUUzLjEwMFVVVVVVVVVVVVVMQU1FMy4xMDBVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/80LEWwAAA0gAAAAAVVVVVVVVVVVVVVVVVVVVVVVVVVVMQU1FMy4xMDBVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/80DEpAAAA0gAAAAAVVVVVVVVVVVVVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsSjAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVTEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV//NCxKMAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVTEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV//NAxKQAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/80LEowAAA0gAAAAAVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVU=';

// Один свободный ввод: кому звоним, повод, детали — всё в details.
export function generateZvonokText({celebId, details}) {
    if (MOCK) {
        const seed = details?.length || 0;
        return new Promise(resolve => setTimeout(
            () => resolve({text: MOCK_TEXTS[seed % MOCK_TEXTS.length]}),
            1000,
        ));
    }
    return apiPostWithRetry('/celebs/zvonki/generate-text', {
        celeb_id: celebId,
        details,
    });
}

// Без ретраев: эндпоинт с жёстким rate-limit, повтор только по клику юзера.
// Превью — это и есть аудио звонка: бэкенд сразу заливает его в S3 и
// возвращает audio_url, который потом уходит в /schedule или на покупку.
export function generateZvonokAudioPreview({celebId, text}) {
    if (MOCK) {
        return new Promise(resolve => setTimeout(
            () => resolve({
                audio_base64: MOCK_AUDIO_BASE64,
                audio_url: `https://storage.yandexcloud.net/selebrus-generations/zvonki/mock-${Date.now()}.mp3`,
                duration_sec: 12.5,
            }),
            1500,
        ));
    }
    return apiPost('/celebs/zvonki/audio-preview', {
        celeb_id: celebId,
        text,
    });
}

// Без ретраев: запрос списывает кредит.
export function scheduleZvonok({celebId, phone, callText, audioUrl, audioDurationSec, scheduledAt, timezone, accountId = ACCOUNT_ID}) {
    if (MOCK) {
        return new Promise(resolve => setTimeout(
            () => resolve({id: `mock_${Date.now()}`, status: 'scheduled', scheduled_at: scheduledAt}),
            300,
        ));
    }
    return apiPost('/celebs/zvonki/schedule', {
        account_id: accountId,
        celeb_id: celebId,
        phone,
        call_text: callText,
        audio_url: audioUrl,
        audio_duration_sec: audioDurationSec ?? null,
        scheduled_at: scheduledAt,
        timezone: timezone || null,
    });
}

// Онлайн-подписки на статус звонка нет намеренно: звонок может быть через
// неделю, никто не ждёт его в реальном времени. Статусы видны в «Моих заказах»
// через поллинг account-status.
export function cancelZvonok(callId, {accountId = ACCOUNT_ID} = {}) {
    if (MOCK) {
        return Promise.resolve({id: callId, status: 'cancelled'});
    }
    return apiPost(`/celebs/zvonki/${callId}/cancel`, {account_id: accountId});
}
